/**
 * @flow
 * @relayHash bb55a710d8c45419235976d32f281d6a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type App_viewer$ref = any;
export type AppWrapper_QueryVariables = {||};
export type AppWrapper_QueryResponse = {|
  +viewer: ?{|
    +me: ?{|
      +canDelete: ?boolean
    |},
    +$fragmentRefs: App_viewer$ref,
  |}
|};
export type AppWrapper_Query = {|
  variables: AppWrapper_QueryVariables,
  response: AppWrapper_QueryResponse,
|};
*/


/*
query AppWrapper_Query {
  viewer {
    me {
      canDelete
      id
    }
    ...App_viewer
    id
  }
}

fragment App_viewer on Viewer {
  id
  me {
    id
    name
    email
    canDelete
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "canDelete",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "AppWrapper_Query",
  "id": null,
  "text": "query AppWrapper_Query {\n  viewer {\n    me {\n      canDelete\n      id\n    }\n    ...App_viewer\n    id\n  }\n}\n\nfragment App_viewer on Viewer {\n  id\n  me {\n    id\n    name\n    email\n    canDelete\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "AppWrapper_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "me",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              v0
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "App_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "AppWrapper_Query",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "me",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              v0,
              v1,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "email",
                "args": null,
                "storageKey": null
              }
            ]
          },
          v1
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6dee663409001615fe04554521210412';
module.exports = node;



// WEBPACK FOOTER //
// src/__generated__/AppWrapper_Query.graphql.js